import { DEV, MODE } from '@pukka/common/constants';
import { SetupWorker, rest, setupWorker } from 'msw';

let worker: SetupWorker;

async function getWorker() {
  if (DEV && MODE === 'dev') {
    if (!worker) {
      // Lazy load the handlers so it wouldn't need to be bundled.
      const { handlers } = await import('../handler');

      worker = setupWorker(...handlers);
    }

    return worker;
  }

  return undefined;
}

export { rest, getWorker };
